<script lang="ts">
  import { Menu, MenuItem } from "@gl/design-system"
  import { getContext } from "svelte"
  import { _ } from "svelte-i18n"
  import { faCity, faCode, faCopy, faGear, faHouse, faTable, faTv, faUpload } from "@fortawesome/pro-regular-svg-icons"
  import { navigateCustomUrl } from "../utils/navigateCustom"
  import { Link } from "svelte-routing"
  const { isAuthorized } = getContext("isAuthorized")

  export let selected: String
</script>

<div class="main">
  <div class="flex-menu">
    <div class="theme-dark menu">
      <Menu>
        {#if $isAuthorized("cut_create", "cut-manager")}
          <Link to={navigateCustomUrl("/home")}>
            <MenuItem selected={selected.startsWith("home")} icon={faHouse}>
              <div class="label">
                {$_("common.home")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("job_list", "cut-manager")}
          <Link to={navigateCustomUrl("/jobs")}>
            <MenuItem selected={selected.startsWith("jobs")} icon={faTable}>
              <div class="label">
                {$_("common.jobs")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("file_list", "cut-manager")}
          <Link to={navigateCustomUrl("/files")}>
            <MenuItem selected={selected.startsWith("files")} icon={faTable}>
              <div class="label">
                {$_("common.files")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("copyjob_list", "cut-manager")}
          <Link to={navigateCustomUrl("/copyjobs")}>
            <MenuItem selected={selected.startsWith("copyjobs")} icon={faCopy}>
              <div class="label">
                {$_("common.copyjobs")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("channel_list", "cut-manager")}
          <Link to={navigateCustomUrl("/channels")}>
            <MenuItem selected={selected.startsWith("channels")} icon={faTv}>
              <div class="label">
                {$_("common.channels")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("location_list", "cut-manager")}
          <Link to={navigateCustomUrl("/locations")}>
            <MenuItem selected={selected.startsWith("locations")} icon={faCity}>
              <div class="label">
                {$_("common.locations")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("compositor_list", "cut-manager")}
          <Link to={navigateCustomUrl("/compositors")}>
            <MenuItem selected={selected.startsWith("compositors")} icon={faGear}>
              <div class="label">
                {$_("common.compositors")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("copymanager_list", "cut-manager")}
          <Link to={navigateCustomUrl("/copymanagers")}>
            <MenuItem selected={selected.startsWith("copymanagers")} icon={faGear}>
              <div class="label">
                {$_("common.copymanagers")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("destination_list", "cut-manager")}
          <Link to={navigateCustomUrl("/destinations")}>
            <MenuItem selected={selected.startsWith("destinations")} icon={faUpload}>
              <div class="label">
                {$_("common.destinations")}
              </div>
            </MenuItem>
          </Link>
        {/if}

        {#if $isAuthorized("docs_access", "cut-manager")}
          <Link to={navigateCustomUrl("/openapi")}>
            <MenuItem selected={selected.startsWith("openapi")} icon={faCode}>
              <div class="label">
                {$_("common.openapi")}
              </div>
            </MenuItem>
          </Link>
        {/if}
      </Menu>
    </div>
  </div>
  <div class="p-6 content">
    <slot />
  </div>
</div>

<style>
  .flex-menu {
    width: 262px;
  }

  .menu {
    position: fixed;
    height: 100%;
    padding: 14px;
    width: 262px;
    z-index: 10;
  }

  .content {
    margin: 0 auto;
    width: 75%;
  }

  .main {
    height: 100%;
    min-height: 100vh;
    display: flex;
    background-color: #f2f2f2;
  }

  @media screen and (max-width: 1300px) {
    .menu,
    .flex-menu {
      width: 70px;
      padding: 0;
    }

    .menu :global(.gl-icon) {
      margin: 0;
    }

    .label {
      display: none;
    }
  }
</style>
